import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    LanesTabs,
} from 'app/enums/domain.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import Overview from './Overview'
import LaneImplementation from './LaneImplementation'
import Notifications from './Notifications'
import tableConfig from './LaneOpsInformationDto.config'

const DOMAIN_NAME = 'LaneOpsInformationDto'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const LanesTable = () => {
    const tabs: SidebarTab[] = [
        {
            url: CommonRoutes.Overview,
            label: 'Overview',
            Component: Overview,
        },
        {
            url: LanesTabs.LaneImplementation,
            label: 'Lane Implementation',
            Component: LaneImplementation,
        },
        {
            url: LanesTabs.Notifications,
            label: 'Notifications',
            Component: Notifications,
        },
    ]

    // NOTE: the 'Upcoming Lanes' tab has its own forms tabs, defined in
    // LaneOpsInformationDto.config.ts

    return (
        <SkyNetDomain
            name={DOMAIN_NAME}
            sidebarTabs={tabs}
            tableConfig={tableConfig}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}

export default LanesTable
